// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { ToolboxModal } from './toolbox-modal'
import { ToolboxCulturalContentsModal } from './toolbox-cultural-contents-modal'
import { ToolboxCommunicationToolsModal } from './toolbox-communication-tools-modal'

const TOOLBOX_COMPONENT_ID = 'toolbox'
const CULTURAL_CONTENTS_COMPONENT_ID = 'toolboxCulturalContents'
const COMMUNICATION_TOOLS_COMPONENT_ID = 'toolboxCommunicationTools'

export const showToolboxModal = () => addModal({ id: TOOLBOX_COMPONENT_ID })

export const showToolboxCulturalContentsModal = async () => {
  await closeCurrentModal()
  addModal({ id: CULTURAL_CONTENTS_COMPONENT_ID })
}

export const showToolboxCommunicationToolsModal = async () => {
  await closeCurrentModal()
  addModal({ id: COMMUNICATION_TOOLS_COMPONENT_ID })
}

export default {
  [TOOLBOX_COMPONENT_ID]: {
    Component: ToolboxModal,
  },
  [CULTURAL_CONTENTS_COMPONENT_ID]: {
    Component: ToolboxCulturalContentsModal,
  },
  [COMMUNICATION_TOOLS_COMPONENT_ID]: {
    Component: ToolboxCommunicationToolsModal,
  },
}
